import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';

export type TemplateDownloadScope = 'FILTERED' | 'ALL';

export interface MassiveLoadTemplateDialogData {
  entityLabel: string;
  filteredCount: number;
}

@Component({
  selector: 'app-massive-load-template-dialog',
  standalone: true,
  imports: [MatDialogContent, MatDialogActions],
  templateUrl: './massive-load-template-dialog.html',
  styleUrl: './massive-load-template-dialog.css'
})
export class MassiveLoadTemplateDialog {
  constructor(
    public dialogRef: MatDialogRef<MassiveLoadTemplateDialog>,
    @Inject(MAT_DIALOG_DATA) public data: MassiveLoadTemplateDialogData
  ) {
  }

  select(scope: TemplateDownloadScope): void {
    this.dialogRef.close(scope);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
